import React from 'react';

import {IconCheckmark, IconEdit, IconWithTooltip} from '@appComponents/IconCollection';
import {Authorization} from '@appComponents/Authorization';
import {REPORT} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';
import {getLink} from '@appComponents/Link';
import {renderIncidentDuration, renderIncidentType, renderScopes} from '@modules/events/utils/report';

export const authorizationObject = {
    [REPORT]: SECURITY_PRIVILEGES_READ,
};

export const rowRenderer = (eventId, column, row) => {
    switch (column) {
        case 'type':
            return row.report_type?.name;
        case 'scope':
            return row.includes_all_streams ? 'All streams' : renderScopes(row.report_scopes_view);
        case 'incident_source':
            return row.incident_source.name ? row.incident_source.name : '';
        case 'incident_type':
            return renderIncidentType(row.incident_type);
        case 'duration':
            return renderIncidentDuration(row.incident_duration, row.incident_duration_unit);
        case 'downtime':
            return row.count_as_downtime ? <IconCheckmark/> : '';
        case 'comment':
            return row.comment
                ? <IconWithTooltip
                    name='comment alternate outline'
                    tooltip={row.comment}
                    iconProps={{size: 'large'}}
                    popupProps={{className: '--tooltip--with-linebreaks'}}
                />
                : null;
        case 'actions':
            return (
                <Authorization authorization={authorizationObject}>
                    <div className='actions-list-icon'>
                        <IconEdit
                            size='large'
                            link={getLink('events.reportIncidents.edit', {reportId: row.id, id: eventId})} resource={REPORT}/>
                    </div>
                </Authorization>
            );
        default:
            return null;
    }
};

